"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const thread_1 = require("../../../app/dist/thread");
exports.toolDef = {
    name: 'loom_rename_thread',
    description: "Rename a thread folder (loom/{weaveId}/{threadId}) — the slug only. The thread's stable identity (th_ ULID in thread.md) and all its docs are untouched, so depends_on edges and every backlink survive. (Legacy thread-prefixed idea/design filenames are flattened to idea.md/design.md so the rename holds pre-migration.) Use this tool — do not rename thread folders directly.",
    inputSchema: {
        type: 'object',
        properties: {
            weaveId: { type: 'string', description: 'Weave id that contains the thread.' },
            threadId: { type: 'string', description: 'Current thread id (folder name).' },
            newThreadId: { type: 'string', description: 'New thread id (folder name).' },
        },
        required: ['weaveId', 'threadId', 'newThreadId'],
    },
};
async function handle(root, args) {
    const result = await (0, thread_1.renameThread)({ weaveId: args['weaveId'], threadId: args['threadId'], newThreadId: args['newThreadId'] }, { getActiveLoomRoot: () => (0, dist_1.getActiveLoomRoot)(root), fs });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
